<template lang="pug">
.briq-alert(:class="`briq-${variant}${column ? ' column' : ''}`")
  BriqIcon(name="icon-info-icon")
  slot
</template>

<script>
export default {
  name: 'BriqAlert',
  props: {
    variant: {
      type: String,
      validator: x => x === 'warning' || x === 'error' || x === 'info',
    },
    column: {
      type: Boolean,
      default: false
    }
  },
}
</script>

<style lang="stylus">
.briq-alert
  background #fff3e9
  border 1px solid #ffd7b6
  border-radius 4px
  padding 8px 16px
  display flex
  align-items center
  font-weight bold

  &.column
    flex-direction: column
    align-items: flex-start

    span {
      margin-top: 8px
    }

  .icon
    margin-right 10px
    fill #ff811c

.briq-alert.briq-warning
  background #fff3e9
  border 1px solid #ffd7b6
  .icon
    fill #ff811c

.briq-alert.briq-info
  background #e5f3fe
  border 1px solid #2196F3
  .icon
    fill #2196F3
</style>
